import {
    Box,
    Button,
    Divider,
    Stack,
    Typography,
} from '@mui/material';
import { Trash2 } from 'react-feather';


export const UserList = ({ useFetchInit, dataModal }) =>{
    
    const { Actions } = useFetchInit
    const { handleClickDeleteAssignment } = Actions

    const { dataRequest } = dataModal

    return(
        <>
            <div className="border-bottom border-dark"></div>
            <Typography variant="subtitle2" sx={{ pt: 2, mb: 1, pb:4 }} fontWeight={600}>
                Usuarios asignados
            </Typography>

            {dataRequest?.usuarios?.length ? (
                <Stack spacing={1.5}>
                    {dataRequest.usuarios.map((user) => (
                        <Box key={user.idasignacion}>
                            <Stack
                                direction={{ xs: 'column', sm: 'row' }}
                                justifyContent="space-between"
                                alignItems={{ xs: 'flex-start', sm: 'center' }}
                                spacing={1}
                            >
                                <Box>
                                    <Typography variant="body2" fontWeight={600}>
                                        {user.nombre || user.usuario}
                                    </Typography>

                                    {user.usuario && (
                                        <Typography variant="body2" color="text.secondary">
                                            Usuario: {user.usuario}
                                        </Typography>
                                    )}

                                    {user.correo && (
                                        <Typography variant="body2" color="text.secondary">
                                            {user.correo}
                                        </Typography>
                                    )}
                                </Box>

                                <Button
                                    size="small"
                                    color="error"
                                    onClick={() => handleClickDeleteAssignment(user.idasignacion)}
                                >
                                    <Trash2/> &nbsp; Quitar asignación
                                </Button>
                            </Stack>
                            <Divider sx={{ mt: 1.5 }} />
                        </Box>
                    ))}
                </Stack>
            ) : (
                <Typography variant="body2" color="text.secondary">
                    Esta caja aún no tiene usuarios asignados.
                </Typography>
            )}
        </>
    )
}